module.exports = __webpack_public_path__ + "img/test.cb1eceb3.png";